// extracted by mini-css-extract-plugin
export default {"contentfulHeroContainer":"ContentfulHero-module__contentfulHeroContainer--HyE8X","videoContainer":"ContentfulHero-module__videoContainer--gM7Jt"};